import { OneChipInfoProvider, useOneChipInfoContext } from 'contexts/OneChipInfoContext';

import { SvgIcon } from '@mui/material';
import { ReactComponent as PublicIcon } from 'assets/icons/assign_public_icon.svg';
import { ReactComponent as PrivateIcon } from 'assets/icons/assign_private_icon.svg';
import { AssignButtonContainer } from 'modules/onechip-details/meerkat/containers/AssignContainer';
import LoadingButton from '@mui/lab/LoadingButton';
import { useModal } from 'components/shared/modal';

import PlanDetailsContainer from 'modules/modals/PlanDetails/containers/PlanDetailsContainer';
import { useTranslation } from 'react-i18next';
import withEmptyData from 'hoc/witEmptyData';
import SharedSelectPlan from 'modules/modals/SelectPlan/containers/SharedSelectPlan';
import useSelectPlan from 'modules/modals/SelectPlan/hooks/useSelectPlan';

const MeerkatSelectPlan = ({ onComplete = () => {} }) => {
  const modal = useModal({ stacked: false });

  const { t } = useTranslation();

  const { info } = useOneChipInfoContext();
  const infoData = info.data;
  const { meerkatPublicVpnEnabled = false, meerkatPrivateVpnEnabled = false, eid = null } = infoData?.esim ?? {};
  const additionPlanParams = {
    meerkatPublicVpnEnabled,
    meerkatPrivateVpnEnabled,
    eid,
  };

  const preselect = (infoData) => {
    return {
      service: [
        {
          label: 'Meerkat',
          value: 'meerkat',
        },
      ],
    };
  };

  const readOnly = () => ({
    service: true,
  });

  const handleOpenPlanDetailsModal = (data) => {
    modal.openModal(
      PlanDetailsContainer,
      {
        data: { ...data, ...additionPlanParams },
        isMeerkat: true,
        onComplete,
      },
      {
        title: [
          { name: 'MeerkatPlanSelectionModal', title: t('views.onechip_details.meerkat.actions.add_app') },
          { name: '', title: data.planName },
        ],
        fullWidth: true,
        maxWidth: 'md',
        close: true,
        sx: {
          '& .ModalContentWrapper-root': {
            backgroundColor: '#F5F5F5',
          },
        },
      }
    );
  };

  return (
    <SharedSelectPlan
      readOnly={readOnly}
      preselect={preselect}
      onPlanOpen={handleOpenPlanDetailsModal}
      usePlanList={useSelectPlan}
    >
      {(plan) => (
        <>
          <AssignButtonContainer
            modal={modal}
            key={'public'}
            data={{ ...additionPlanParams, ...plan }}
            type="public"
            onComplete={onComplete}
          >
            {({ onAssign, isLoadingAssign }) => (
              <LoadingButton
                variant="contained"
                fullWidth
                startIcon={<SvgIcon component={PublicIcon} inheritViewBox />}
                onClick={onAssign}
                loading={isLoadingAssign}
                disabled={isLoadingAssign}
              >
                Assign Public IP
              </LoadingButton>
            )}
          </AssignButtonContainer>
          <AssignButtonContainer
            modal={modal}
            key={'private'}
            data={{ ...additionPlanParams, ...plan }}
            type="private"
            onComplete={onComplete}
          >
            {({ onAssign, isLoadingAssign }) => (
              <LoadingButton
                variant="outlined"
                fullWidth
                startIcon={<SvgIcon component={PrivateIcon} sx={{ fill: 'none' }} inheritViewBox />}
                onClick={onAssign}
                loading={isLoadingAssign}
                disabled={isLoadingAssign}
              >
                Assign Private IP
              </LoadingButton>
            )}
          </AssignButtonContainer>
        </>
      )}
    </SharedSelectPlan>
  );
};

const withOnechipInfoProvider = (Component) => {
  return (props) => (
    <OneChipInfoProvider>
      <Component {...props} />
    </OneChipInfoProvider>
  );
};

export default withOnechipInfoProvider(MeerkatSelectPlan);
